<button
  (click)="clickedButton($event)"
  class="button"
  [ngClass]="[
    cancel ? 'cancel-button' : '',
    disabled ? 'disabled' : '',
    fab ? 'fab' : ''
  ]"
  id="{{ id }}"
>
  <span class="text">
    {{ text }}
  </span>
</button>
